import { Popover } from 'antd'
import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export type EditableBadgeRootProps = {
  maxVisible?: number
} & HTMLAttributes<HTMLDivElement>

export const EditableBadgeRoot = ({
  className,
  children,
  maxVisible,
  ...props
}: EditableBadgeRootProps) => {
  const childrenArray = Array.isArray(children) ? children : [children]

  let visibleItems = childrenArray
  let hiddenItems = []

  if (maxVisible) {
    visibleItems = childrenArray.slice(0, maxVisible)
    hiddenItems = childrenArray.slice(maxVisible)
  }

  return (
    <div
      className={cn(
        'mt-1 flex items-center justify-start gap-2 text-sm',
        className
      )}
      {...props}
    >
      {visibleItems}

      {hiddenItems.length ? (
        <Popover
          content={
            <div className="flex max-w-[250px] flex-col gap-2">
              {hiddenItems.map((child, index) => (
                <div key={index}>{child}</div>
              ))}
            </div>
          }
          placement="bottom"
        >
          <div className="cursor-pointer rounded-xl bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-600 hover:bg-gray-300">
            +{hiddenItems.length}
          </div>
        </Popover>
      ) : null}
    </div>
  )
}
